import { render, staticRenderFns } from "./Packaging2.vue?vue&type=template&id=daac6d4a&scoped=true&"
import script from "./Packaging2.vue?vue&type=script&lang=js&"
export * from "./Packaging2.vue?vue&type=script&lang=js&"
import style0 from "./Packaging2.vue?vue&type=style&index=0&id=daac6d4a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daac6d4a",
  null
  
)

export default component.exports